import { FC } from 'react'
import { required } from 'forms'
import IconInformation from 'remixicon/icons/System/information-line.svg?react'

import OrderYarcheGuestCreateFormRoute from './OrderYarcheGuestCreateFormRoute/OrderYarcheGuestCreateFormRoute'
import MockOrderYarcheData from './MockOrderYarcheData'
import OrderCargoSize from './OrderCargoSize'
import OrderYarcheGuestCreateSummary from './OrderYarcheGuestCreateSummary'

const OrderYarcheGuestCreateForm: FC<{ isShowPhone: boolean }> = ({ isShowPhone }) => (
  <>
    <div className="grid grid-cols-1 3md:grid-cols-[auto_380px]">
      <div className="overflow-hidden px-0 md:px-6">
        <div className="grid grid-cols-[auto_1fr] items-center gap-x-4 rounded bg-attention-container p-3">
          <IconInformation className="text-on-surface-variant" containerSize="nm" size="xs" />
          <div className="text-body-md">
            Сервис отправки и&nbsp;получения грузов через магазины &laquo;Ярче&raquo; работает в&nbsp;тестовом режиме.
            Пока доступны только магазины Томска и&nbsp;Новосибирска.
          </div>
        </div>

        <div className="mb-2 mt-4 text-headline-sm">Откуда</div>
        <OrderYarcheGuestCreateFormRoute mode="departurePoint" validate={required} />
        <div className="mb-2 mt-4 text-headline-sm">Куда</div>
        <OrderYarcheGuestCreateFormRoute mode="destinationPoint" validate={required} />
        <div className="mb-2 mt-4 text-headline-sm">Отправление</div>
        <OrderCargoSize />
      </div>
      <div className="px-0 py-4 md:px-6">
        <OrderYarcheGuestCreateSummary className="sticky top-[90px] z-sticky" isShowPhone={isShowPhone} />
      </div>
    </div>
    <MockOrderYarcheData />
  </>
)

export default OrderYarcheGuestCreateForm
